import { useEffect, useState } from "react";
import { Menu, X, Microscope } from "lucide-react";
import { COMPANY } from "@/lib/site";

const links = [
  { href: "#services", label: "Services", testId: "nav-link-services" },
  { href: "#operational-dashboard", label: "Operational Dashboards", testId: "nav-link-dashboard", isNew: true },
  { href: "#about", label: "About", testId: "nav-link-about" },
  { href: "#process", label: "Process", testId: "nav-link-process" },
  { href: "#certifications", label: "Certifications", testId: "nav-link-certifications" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200/70 shadow-[0_1px_0_0_rgba(15,23,42,0.03)]"
          : "bg-white/60 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-2.5 group"
          >
            <img
              src="/logo.png"
              alt="Xpertee"
              className="h-10 w-auto"
              width="169"
              height="40"
            />
            <span className="hidden sm:inline text-slate-500 font-normal text-base">
              Pharma Services Private Limited
            </span>
          </a>

          <div className="hidden md:block">
            <a
              href="#contact"
              data-testid="nav-contact-button"
              className="inline-flex items-center bg-teal-700 hover:bg-teal-800 text-white px-6 py-3 text-sm font-medium transition-colors"
            >
              Contact Us
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 text-slate-800"
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        <nav className="hidden md:flex items-center gap-9 h-12 border-t border-slate-100">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="relative text-sm font-medium text-slate-600 hover:text-teal-700 transition-colors inline-flex items-center gap-2"
            >
              {l.label}
              {l.isNew && (
                <span className="inline-flex items-center bg-teal-700 text-white text-[9px] font-semibold uppercase tracking-[0.15em] px-1.5 py-0.5 animate-pulse">
                  New
                </span>
              )}
            </a>
          ))}
        </nav>

        {open && (
          <div className="md:hidden pb-6 border-t border-slate-200/70 pt-4" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`${l.testId}-mobile`}
                  onClick={() => setOpen(false)}
                  className="text-base font-medium text-slate-700 hover:text-teal-700 inline-flex items-center gap-2"
                >
                  {l.label}
                  {l.isNew && (
                    <span className="inline-flex items-center bg-teal-700 text-white text-[9px] font-semibold uppercase tracking-[0.15em] px-1.5 py-0.5 animate-pulse">
                      New
                    </span>
                  )}
                </a>
              ))}
              <a
                href="#contact"
                data-testid="nav-contact-button-mobile"
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center bg-teal-700 text-white px-6 py-3 text-sm font-medium"
              >
                Contact Us
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
